// VineCharacteristics.js

import { useState, useEffect, useRef, useContext } from "react";
import { useFetch } from "use-http";
import { Form, Box, Text, Button, Layer, Header, Image, Spinner, Select, TextInput, grommet, Grommet } from "grommet";
import { getDBURL, updateStateHandler, isValidYearString, correctTimeZone } from "../Utils/Utils";
import { UserContext } from "../../App";
import { useDataContext } from '../Contexts/DataContext';
import { deepMerge } from "grommet/utils";
import useTrapFocus from "../Utils/useTrapFocus";
import RadioWithText from "./RadioWithText";

import {
    getTypeOptions,
    getBudBreakOptions,
    getRainResistanceOptions,
    getChillingOptions,
    getHarvestOptions
} from "../Utils/RBGUtils";

const VineCharacteristics = (props) => {
    const { cultivarData, setCultivarData, readOnly } = props;
    console.log('VineCharacteristics props  >>  ', props);

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    return (
        <Box background="transparent" fill ref={modalRef} tabIndex="-1" id="vine-char">

            <Box margin={{vertical: "10px"}} >
                <Text alignSelf="center" color="brand" size="24px"
                    style={{
                        background: "linear-gradient(to left, #00739D, #f9dd94 100%)",
                        backgroundPosition: "0 100%",
                        backgroundSize: "100% 3px",
                        backgroundRepeat: "repeat-x",
                        fontStyle: "italic"}}
                        > <strong>Vine Characteristics:</strong></Text>                              
            </Box>

            {/* Content rows */}
            <Box direction="row-responsive" alignSelf="center" width="98%"background="transparent" >
                {/* Fruit Color Radio */}
                <Box direction="row" width="50%" align="center" background="transparent">                                    
                <RadioWithText
                        text="Fruit Color:"
                        getOptions={getTypeOptions}
                        initValue={cultivarData.Type}
                        stateHandler={setCultivarData}
                        fieldName="Type"
                        disable={readOnly}
                    />
                </Box>

                {/* Harvest Radio */}
                <Box direction="row" width="50%" align="center">                                    
                <RadioWithText
                    text="Harvest:"
                    getOptions={getHarvestOptions}
                    initValue={cultivarData.Harvest} 
                    stateHandler={setCultivarData}
                    fieldName="Harvest"
                    disable={readOnly}
                />
                </Box>    

            </Box>

            <Box direction="row-responsive" alignSelf="center" width="98%" background="transparent" >
                {/* Bud Break Radio */}
                <Box direction="row" width="50%" align="center" background="transparent">
                <RadioWithText
                    text="Bud Break:"
                    getOptions={getBudBreakOptions}
                    initValue={cultivarData.BudBreak} 
                    stateHandler={setCultivarData}
                    fieldName="BudBreak"
                    disable={readOnly}
                />
                </Box>

                {/* Rain Resistance Radio */}
                <Box direction="row" width="50%" align="center">                                    
                <RadioWithText
                    text="Rain Resistance:"
                    getOptions={getRainResistanceOptions}
                    initValue={cultivarData.RainResistance} 
                    stateHandler={setCultivarData}
                    fieldName="RainResistance"
                    disable={readOnly}
                />
                </Box>                                     
            </Box>                            

            <Box direction="row-responsive" alignSelf="center" width="98%" background="transparent" >
                
                {/* Chilling Radio */}
                <Box direction="row" width="50%" align="center" background="transparent">
                <RadioWithText
                    text="Chilling:"
                    getOptions={getChillingOptions}
                    initValue={cultivarData.Chilling} 
                    stateHandler={setCultivarData}
                    fieldName="Chilling"
                    disable={readOnly}
                />
                </Box>                                                         
                <Box direction="row" width="50%" align="center" background="transparent">
                </Box>
            </Box> 
        </Box>
    );
}

export default VineCharacteristics;